import { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { 
    doc, 
    getDoc, 
    onSnapshot, 
    collection, 
    writeBatch, 
    updateDoc
} from 'firebase/firestore'; 

// PYTYVÕHÁRA: Firebase config unificado mba'eaty
import { db } from '../../../../../firebase/config';

/**
 * Tembipuru omoheko porãva arange pyahu ojejerurehaguéicha (es-AR)
 * Ko tembipuru omoambue arange ISO rehegua peteĩ arange iporãvape yvypórape g̃uarã.
 */
const formatCustomDate = (date = new Date()) => {
    const optionsDate = { day: 'numeric', month: 'long', year: 'numeric' };
    const formatterDate = new Intl.DateTimeFormat('es-AR', optionsDate);
    const datePart = formatterDate.format(date); // "25 de junio de 2026"
    
    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    const ampm = hours >= 12 ? 'p.m.' : 'a.m.';
    hours = hours % 12;
    hours = hours ? hours : 12; // Ara 12
    
    const formattedTime = `${hours}:${minutes}:${seconds} ${ampm}`;
    return `${datePart} a las ${formattedTime} UTC-3`;
};

/**
 * useDetalleCotizacionArt - Tembipuru opytáva atómiko ha analítiko mbyatypýpe.
 */
export const useDetalleCotizacionArt = (initialCotizacion, onBack) => {
    const [cotizacion, setCotizacion] = useState(initialCotizacion);
    const currentPathRef = useRef(initialCotizacion?.path);

    useEffect(() => {
        if (initialCotizacion) {
            setCotizacion(initialCotizacion);
            currentPathRef.current = initialCotizacion.path;
        }
    }, [initialCotizacion]);

    const [isGenerating, setIsGenerating] = useState(false);
    const [fetchedClient, setFetchedClient] = useState(null);
    const [loading, setLoading] = useState(true);

    const [showContratoModal, setShowContratoModal] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false); 
    const [notification, setNotification] = useState({ show: false, message: '', type: 'success' });
    
    const [contratoPrefill, setContratoPrefill] = useState(null);
    const [clientDataForModal, setClientDataForModal] = useState(null);
    const [selectedComparacion, setSelectedComparacion] = useState(null);

    // --- 1. FIRESTORE ORENDÚVA APYTEPE ---
    useEffect(() => {
        if (!currentPathRef.current) return;
        
        const unsubscribe = onSnapshot(doc(db, currentPathRef.current), (snap) => {
            if (snap.exists()) {
                setCotizacion({ id: snap.id, path: snap.ref.path, ...snap.data() });
            }
            setLoading(false);
        }, (err) => {
            console.error("Error en snapshot detalle cotizacion:", err);
            setLoading(false);
        });
        
        return () => unsubscribe();
    }, [cotizacion?.path]);

    // --- 2. MBOYVEGUA HYDRATION MOKÕI REHEGUA (CLIENTE HA PROSPECTO) ---
    useEffect(() => {
        const fetchClientData = async () => {
            const targetClientId = cotizacion?.clienteId || cotizacion?.entidadId;
            if (!targetClientId) return;

            try {
                const clientDoc = await getDoc(doc(db, 'public/data/clientes', targetClientId));
                if (clientDoc.exists()) {
                    setFetchedClient({ id: clientDoc.id, ...clientDoc.data(), tipoEntidad: 'CLIENTE' });
                    return;
                }
                const prospectDoc = await getDoc(doc(db, 'public/data/prospectos', targetClientId));
                if (prospectDoc.exists()) {
                    setFetchedClient({ id: prospectDoc.id, ...prospectDoc.data(), tipoEntidad: 'PROSPECTO' });
                }
            } catch (error) { 
                console.error("Error hidratando cliente en detalle cotización:", error); 
            }
        };
        fetchClientData();
    }, [cotizacion?.clienteId, cotizacion?.entidadId]);

    const sourceData = useMemo(() => fetchedClient || cotizacion, [fetchedClient, cotizacion]);
    const isProspect = useMemo(() => (cotizacion?.tipoEntidad || fetchedClient?.tipoEntidad) === 'PROSPECTO', [cotizacion, fetchedClient]);
    const isContratoGenerado = useMemo(() => !!(cotizacion?.contratoVinculadoId || cotizacion?.nContratoVinculado || cotizacion?.estado === 'Cerrada Ganada'), [cotizacion]);

    // --- 3. RENDAPY PYAHU ÑEMBOHESE RENDY RENDY HAGUÃ ---
    const { ofertas, listaVisual } = useMemo(() => {
        if (!cotizacion || !cotizacion.cotizaciones) return { ofertas: [], listaVisual: [] };
        const validas = [];
        const invalidas = [];
        cotizacion.cotizaciones.forEach(c => {
            const estado = (c.estadoCotizacion || c.estadoRow || '').trim();
            const alicuota = parseFloat(c.alicuotaCotizada);
            if (alicuota > 0 && !['Solicitada', 'Bloqueada', 'No cotiza', 'Pendiente', 'Stand By'].includes(estado)) {
                validas.push(c);
            } else {
                invalidas.push(c);
            }
        });
        validas.sort((a, b) => parseFloat(a.alicuotaCotizada) - parseFloat(b.alicuotaCotizada));
        return { ofertas: validas, listaVisual: [...validas, ...invalidas] };
    }, [cotizacion?.cotizaciones]);

    const ganadora = useMemo(() => (ofertas.length > 0 ? ofertas[0] : null), [ofertas]);

    useEffect(() => {
        if (ganadora && !selectedComparacion) setSelectedComparacion(ganadora);
    }, [ganadora, selectedComparacion]);

    const ofertaParaCalculos = selectedComparacion || ganadora;

    // --- 4. PROSPECTO LEGAJO REMBIPURU ---
    const prospectInitialData = useMemo(() => {
        if (!fetchedClient || fetchedClient.tipoEntidad !== 'PROSPECTO') return null;
        
        return {
            ...fetchedClient,
            id: fetchedClient.id,
            canal: fetchedClient.canal || cotizacion?.canal || '',
            canalNombreId: fetchedClient.canalNombreId || cotizacion?.canalNombreId || '',
            canalNombre: fetchedClient.canalNombre || cotizacion?.canalNombre || '',
            subcanalNombreId: fetchedClient.subcanalNombreId || cotizacion?.subcanalNombreId || '',
            subcanalNombre: fetchedClient.subcanalNombre || cotizacion?.subcanalNombre || '',
            vendedor: fetchedClient.vendedor || cotizacion?.vendedor || ''
        };
    }, [fetchedClient, cotizacion]);

    // --- 5. KUATIAKUÉRA ÑEMBOHASA ATÓMIKO HA ARANGE AUDITORÍA REHEGUA ---
    const handleConversionSuccess = async (msg, savedClient) => {
        setIsGenerating(true);
        setShowConfirmModal(false);
        try {
            const batch = writeBatch(db);
            const prospectId = fetchedClient.id;
            const clientId = savedClient.id; 

            const prospectRef = doc(db, 'public/data/prospectos', prospectId);
            const clientRef = doc(db, 'public/data/clientes', clientId);
            
            // 1. Ñambogue kuatia oĩva prospectos mbyatypýpe
            batch.delete(prospectRef);

            // 2. Ñamyatyrõ kuatia pyahu oĩva clientes-pe mbyatypýpe
            const clientUpdatePayload = {
                tipoEntidad: 'CLIENTE', 
                conversionMetadata: {   
                    prospectoIdOrigen: prospectId,
                    fechaConversion: formatCustomDate(), // Arange oñemboheko porãva
                    origenConversion: 'Detalle Cotización ART'
                },
                ultimaModificacion: formatCustomDate() // Arange oñemboheko porãva
            };
            batch.update(clientRef, clientUpdatePayload);
            
            // 3. Ñambosako'i kuatia rape ipyahúva
            const oldPath = currentPathRef.current;
            const newPath = `public/data/clientes/${clientId}/cotizaciones_art/${cotizacion.id}`;
            
            const quotePayload = {
                ...cotizacion,
                clienteId: clientId,
                tipoEntidad: 'CLIENTE',
                ultimaModificacion: formatCustomDate() // Arange oñemboheko porãva
            };
            
            const { id: _, path: __, ...cleanedQuote } = quotePayload;

            // 4. Ñamongatu kuatia pyahu batch mbytépe
            batch.set(doc(db, newPath), cleanedQuote);
            
            // 5. Ñambogue kuatia tuja prospectos mbyatypýpe
            if (oldPath !== newPath) {
                batch.delete(doc(db, oldPath));
            }

            // Confirmación de transacciones atómicas
            await batch.commit();

            // 6. Ñamyatyrõ memóripe oĩva mbohovái
            currentPathRef.current = newPath;
            setCotizacion({ ...quotePayload, id: cotizacion.id, path: newPath });
            setFetchedClient({ ...savedClient, ...clientUpdatePayload });
            
            setNotification({ show: true, message: '¡Asegurado dado de alta y cotización trasladada correctamente!', type: 'success' });
        } catch (error) {
            console.error("Error post-procesando la conversión del prospecto:", error);
            setNotification({ show: true, message: 'El cliente se guardó, pero falló el traslado de la cotización.', type: 'error' });
        } finally {
            setIsGenerating(false);
        }
    };

    // --- 6. CONTRATO ÑEMBOSAKO'I HA GESTIÓN MBOTY REHEGUA ---
    const handleContractSuccess = async (msg, contractData) => {
        setShowContratoModal(false);
        const activePath = currentPathRef.current;
        if (!activePath) return;

        try {
            const cotRef = doc(db, activePath);
            const updatePayload = {
                estado: 'Cerrada Ganada',
                nContratoVinculado: contractData.nContratoVinculado || contractData.nContrato || 'S/N',
                contratoVinculadoId: contractData.contratoVinculadoId || contractData.id || '',
                ultimaModificacion: formatCustomDate() // Arange oñemboheko porãva
            };

            await updateDoc(cotRef, updatePayload);
            setCotizacion(prev => ({ ...prev, ...updatePayload }));
            setNotification({ show: true, message: `¡Contrato N° ${updatePayload.nContratoVinculado} emitido y vinculado correctamente!`, type: 'success' });
        } catch (e) {
            console.error("Error crítico vinculando contrato:", e);
            setNotification({ show: true, message: 'El contrato se emitió pero la vinculación falló.', type: 'error' });
        }
    };

    const handleOpenContractModal = () => {
        if (isContratoGenerado || isProspect) return;
        const clientCuit = (sourceData.clienteCuit || sourceData.cuit || sourceData.entidadCuit || '-').toString().trim();

        setContratoPrefill({
            ciiu: cotizacion.ciiu || sourceData.ciiu || '',
            capitas: cotizacion.capitas || '',
            masaSalarial: cotizacion.masaSalarial || '',
            alicuota: ofertaParaCalculos?.alicuotaCotizada || '', 
            compania: ofertaParaCalculos?.compania || '', 
            vendedor: cotizacion.vendedor || sourceData.vendedor || '',
            canal: sourceData.canal || cotizacion.canal || '',
            canalNombreId: sourceData.canalNombreId || cotizacion.canalNombreId || '',
            canalNombre: sourceData.canalNombre || cotizacion.canalNombre || '',
            subcanalNombreId: sourceData.subcanalNombreId || cotizacion.subcanalNombreId || '',
            subcanalNombre: sourceData.subcanalNombre || cotizacion.subcanalNombre || '',
            tipoConversion: 'Cliente',
            cotizacionId: cotizacion.id, 
            cotizacionPath: currentPathRef.current 
        });

        setClientDataForModal({
            ...sourceData,
            id: fetchedClient?.id || cotizacion.clienteId || cotizacion.entidadId,
            cuit: clientCuit,
            vendedor: cotizacion.vendedor || sourceData.vendedor || ''
        });
        setShowContratoModal(true);
    };

    return {
        loading,
        cotizacion,
        fetchedClient,
        sourceData,
        isProspect,
        isContratoGenerado,
        ofertas,
        listaVisual,
        getCustomFormattedDate: formatCustomDate, // Tembipuru ojejuhúva UI-pe g̃uarã
        ofertaParaCalculos,
        selectedComparacion,
        setSelectedComparacion,
        showContratoModal,
        setShowContratoModal,
        showConfirmModal,
        setShowConfirmModal,
        notification,
        setNotification,
        contratoPrefill,
        clientDataForModal,
        isGenerating,
        setIsGenerating,
        prospectInitialData,
        handleConversionSuccess,
        handleContractSuccess,
        handleOpenContractModal
    };
};